// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AboutRouteImport } from './routes/about'
import { Route as AdminRouteRouteImport } from './routes/admin/route'
import { Route as CaseStudiesRouteImport } from './routes/case-studies'
import { Route as CoachRouteImport } from './routes/coach'
import { Route as ConfidenceRouteImport } from './routes/confidence'
import { Route as ConfidenceCheckRouteImport } from './routes/confidence-check'
import { Route as ConfidenceCheckForKidsRouteImport } from './routes/confidence-check-for-kids'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as CopyrightPolicyRouteImport } from './routes/copyright-policy'
import { Route as CorrectionsPolicyRouteImport } from './routes/corrections-policy'
import { Route as EditorialPolicyRouteImport } from './routes/editorial-policy'
import { Route as ExpertsRouteImport } from './routes/experts'
import { Route as FaqRouteImport } from './routes/faq'
import { Route as ForParentsRouteImport } from './routes/for-parents'
import { Route as FutureReadinessRouteImport } from './routes/future-readiness'
import { Route as GlossaryRouteImport } from './routes/glossary'
import { Route as ImpactRouteImport } from './routes/impact'
import { Route as ImpersonateRouteImport } from './routes/impersonate'
import { Route as InstallRouteImport } from './routes/install'
import { Route as LearningJourneysRouteImport } from './routes/learning-journeys'
import { Route as MembershipCheckoutRouteImport } from './routes/membership-checkout'
import { Route as ParentDashboardRouteImport } from './routes/parent-dashboard'
import { Route as PartnerRouteImport } from './routes/partner'
import { Route as PersonalityAssessmentRouteImport } from './routes/personality-assessment'
import { Route as PressRouteImport } from './routes/press'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as PrivacyPolicyRouteImport } from './routes/privacy-policy'
import { Route as ProfileRouteImport } from './routes/profile'
import { Route as ReferRouteImport } from './routes/refer'
import { Route as ReferAndEarnRouteImport } from './routes/refer-and-earn'
import { Route as RefundPolicyRouteImport } from './routes/refund-policy'
import { Route as ResearchMethodologyRouteImport } from './routes/research-methodology'
import { Route as ReviewsRouteImport } from './routes/reviews'
import { Route as SchoolsRouteImport } from './routes/schools'
import { Route as ShowcaseRouteImport } from './routes/showcase'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as TermsOfUseRouteImport } from './routes/terms-of-use'
import { Route as ToolsRouteImport } from './routes/tools'
import { Route as UnsubscribeRouteImport } from './routes/unsubscribe'
import { Route as WriteToFounderRouteImport } from './routes/write-to-founder'
import { Route as AdminIndexRouteImport } from './routes/admin/index'
import { Route as AdminAiVisibilityRouteImport } from './routes/admin/ai-visibility'
import { Route as AdminAssessmentAgeBandsRouteImport } from './routes/admin/assessment-age-bands'
import { Route as AdminAssessmentQuestionsRouteImport } from './routes/admin/assessment-questions'
import { Route as AdminAssessmentSessionsRouteImport } from './routes/admin/assessment-sessions'
import { Route as AdminAssessmentSettingsRouteImport } from './routes/admin/assessment-settings'
import { Route as AdminAssessmentTraitsRouteImport } from './routes/admin/assessment-traits'
import { Route as AdminBlogAuthorsRouteImport } from './routes/admin/blog-authors'
import { Route as AdminBulkVoiceoverRouteImport } from './routes/admin/bulk-voiceover'
import { Route as AdminBusinessAnalyticsRouteImport } from './routes/admin/business-analytics'
import { Route as AdminCategoriesRouteImport } from './routes/admin/categories'
import { Route as AdminCeoRouteImport } from './routes/admin/ceo'
import { Route as AdminCertificatesRouteImport } from './routes/admin/certificates'
import { Route as AdminCoachChatRouteImport } from './routes/admin/coach-chat'
import { Route as AdminConfidenceCheckRouteImport } from './routes/admin/confidence-check'
import { Route as AdminContentCheckerRouteImport } from './routes/admin/content-checker'
import { Route as AdminCourseBackgroundsRouteImport } from './routes/admin/course-backgrounds'
import { Route as AdminCourseGeneratorRouteImport } from './routes/admin/course-generator'
import { Route as AdminCspReportsRouteImport } from './routes/admin/csp-reports'
import { Route as AdminDataAnalyticsRouteImport } from './routes/admin/data-analytics'
import { Route as AdminDialogueCharactersRouteImport } from './routes/admin/dialogue-characters'
import { Route as AdminEdgeCacheRouteImport } from './routes/admin/edge-cache'
import { Route as AdminElevenlabsKeysRouteImport } from './routes/admin/elevenlabs-keys'
import { Route as AdminErrorTrackingRouteImport } from './routes/admin/error-tracking'
import { Route as AdminFounderMessagesRouteImport } from './routes/admin/founder-messages'
import { Route as AdminFutureReadinessRouteImport } from './routes/admin/future-readiness'
import { Route as AdminInfluencersRouteImport } from './routes/admin/influencers'
import { Route as AdminLandingPagesRouteImport } from './routes/admin/landing-pages'
import { Route as AdminLanguagesRouteImport } from './routes/admin/languages'
import { Route as AdminLearningJourneysRouteImport } from './routes/admin/learning-journeys'
import { Route as AdminLogoRouteImport } from './routes/admin/logo'
import { Route as AdminMediaLibraryRouteImport } from './routes/admin/media-library'
import { Route as AdminMetaEventsRouteImport } from './routes/admin/meta-events'
import { Route as AdminMetaPlanEventsRouteImport } from './routes/admin/meta-plan-events'
import { Route as AdminMonitoringRouteImport } from './routes/admin/monitoring'
import { Route as AdminOtpAttemptsRouteImport } from './routes/admin/otp-attempts'
import { Route as AdminParentJourneyRouteImport } from './routes/admin/parent-journey'
import { Route as AdminPaymentHealthRouteImport } from './routes/admin/payment-health'
import { Route as AdminPaymentReconciliationRouteImport } from './routes/admin/payment-reconciliation'
import { Route as AdminPricingAuditRouteImport } from './routes/admin/pricing-audit'
import { Route as AdminPromoCodesRouteImport } from './routes/admin/promo-codes'
import { Route as AdminPublishCheckRouteImport } from './routes/admin/publish-check'
import { Route as AdminReceiptsRouteImport } from './routes/admin/receipts'
import { Route as AdminReferralsRouteImport } from './routes/admin/referrals'
import { Route as AdminRegionalPricingRouteImport } from './routes/admin/regional-pricing'
import { Route as AdminSeoRouteImport } from './routes/admin/seo'
import { Route as AdminSubscriptionsRouteImport } from './routes/admin/subscriptions'
import { Route as AdminTestimonialsRouteImport } from './routes/admin/testimonials'
import { Route as AdminTrashRouteImport } from './routes/admin/trash'
import { Route as AdminUserAnalyticsRouteImport } from './routes/admin/user-analytics'
import { Route as AdminUserReportsRouteImport } from './routes/admin/user-reports'
import { Route as AdminUsersRouteImport } from './routes/admin/users'
import { Route as AdminUtmBuilderRouteImport } from './routes/admin/utm-builder'
import { Route as AdminUtmFunnelRouteImport } from './routes/admin/utm-funnel'
import { Route as AdminVisitorQueriesRouteImport } from './routes/admin/visitor-queries'
import { Route as AdminVoiceoverQueueRouteImport } from './routes/admin/voiceover-queue'
import { Route as AdminWebhookEventsRouteImport } from './routes/admin/webhook-events'
import { Route as AssessmentIndexRouteImport } from './routes/assessment/index'
import { Route as AssessmentSampleReportRouteImport } from './routes/assessment/sample-report'
import { Route as AssessmentStartRouteImport } from './routes/assessment/start'
import { Route as AssessmentsIndexRouteImport } from './routes/assessments/index'
import { Route as AssessmentsSlugRouteImport } from './routes/assessments/$slug'
import { Route as AuthIndexRouteImport } from './routes/auth/index'
import { Route as AuthCallbackRouteImport } from './routes/auth/callback'
import { Route as AuthDebugRouteImport } from './routes/auth/debug'
import { Route as BlogIndexRouteImport } from './routes/blog/index'
import { Route as BlogSlugRouteImport } from './routes/blog/$slug'
import { Route as BlogAuthorsRouteImport } from './routes/blog/authors'
import { Route as CaseStudiesIndexRouteImport } from './routes/case-studies.index'
import { Route as CaseStudiesSlugRouteImport } from './routes/case-studies.$slug'
import { Route as CharactersIndexRouteImport } from './routes/characters/index'
import { Route as CharactersNameRouteImport } from './routes/characters/$name'
import { Route as CourseTrialIndexRouteImport } from './routes/course-trial/index'
import { Route as CourseTrialCourseIdRouteImport } from './routes/course-trial/$courseId'
import { Route as CourseCourseIdRouteImport } from './routes/course/$courseId'
import { Route as CoursesIndexRouteImport } from './routes/courses.index'
import { Route as CoursesSlugRouteImport } from './routes/courses.$slug'
import { Route as LearnIndexRouteImport } from './routes/learn/index'
import { Route as LearnSlugRouteImport } from './routes/learn/$slug'
import { Route as LpSlugRouteImport } from './routes/lp/$slug'
import { Route as MeetIndexRouteImport } from './routes/meet/index'
import { Route as MeetNameRouteImport } from './routes/meet/$name'
import { Route as ParentPinResetRouteImport } from './routes/parent/pin-reset'
import { Route as PartnersApplyRouteImport } from './routes/partners/apply'
import { Route as RSlugRouteImport } from './routes/r/$slug'
import { Route as ResearchIndexRouteImport } from './routes/research.index'
import { Route as ResearchSlugRouteImport } from './routes/research.$slug'
import { Route as SubscriptionIndexRouteImport } from './routes/subscription/index'
import { Route as SubscriptionSuccessAnnualRouteImport } from './routes/subscription/success-annual'
import { Route as SubscriptionSuccessAssessmentRouteImport } from './routes/subscription/success-assessment'
import { Route as SubscriptionSuccessPassRouteImport } from './routes/subscription/success-pass'
import { Route as SubscriptionSuccessQuarterlyRouteImport } from './routes/subscription/success-quarterly'
import { Route as SubscriptionSuccessReportRouteImport } from './routes/subscription/success-report'
import { Route as SubscriptionSuccessTrialRouteImport } from './routes/subscription/success-trial'
import { Route as ToolsIndexRouteImport } from './routes/tools.index'
import { Route as ToolsSlugRouteImport } from './routes/tools.$slug'
import { Route as TopicsIndexRouteImport } from './routes/topics.index'
import { Route as TopicsSlugRouteImport } from './routes/topics.$slug'
import { Route as VsSlugRouteImport } from './routes/vs/$slug'
import { Route as DotlovableOauthConsentRouteImport } from './routes/[.]lovable.oauth.consent'
import { Route as AdminCoursesIndexRouteImport } from './routes/admin/courses/index'
import { Route as AdminParentAssessmentsIndexRouteImport } from './routes/admin/parent-assessments/index'
import { Route as AdminParentAssessmentsSlugRouteImport } from './routes/admin/parent-assessments/$slug'
import { Route as AssessmentChildSessionIdRouteImport } from './routes/assessment/child/$sessionId'
import { Route as AssessmentParentSessionIdRouteImport } from './routes/assessment/parent/$sessionId'
import { Route as AssessmentReportSessionIdRouteImport } from './routes/assessment/report/$sessionId'
import { Route as GoCodeIndexRouteImport } from './routes/go/$code/index'
import { Route as GoCodeCampaignSlugRouteImport } from './routes/go/$code/$campaignSlug'
import { Route as SubscriptionSuccessIndexRouteImport } from './routes/subscription/success/index'
import { Route as SubscriptionSuccessPlanKindRouteImport } from './routes/subscription/success/$planKind'
import { Route as AdminCoursesCourseIdIndexRouteImport } from './routes/admin/courses/$courseId/index'
import { Route as AdminCoursesCourseIdReviewRouteImport } from './routes/admin/courses/$courseId/review'
import { Route as AdminCoursesCourseIdTestRouteImport } from './routes/admin/courses/$courseId/test'
import { Route as AdminCoursesCourseIdVersionsRouteImport } from './routes/admin/courses/$courseId/versions'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AboutRoute = AboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => rootRouteImport
          })
const AdminRouteRoute = AdminRouteRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => rootRouteImport
          })
const CaseStudiesRoute = CaseStudiesRouteImport.update({
            id: '/case-studies',path: '/case-studies',getParentRoute: () => rootRouteImport
          })
const CoachRoute = CoachRouteImport.update({
            id: '/coach',path: '/coach',getParentRoute: () => rootRouteImport
          })
const ConfidenceRoute = ConfidenceRouteImport.update({
            id: '/confidence',path: '/confidence',getParentRoute: () => rootRouteImport
          })
const ConfidenceCheckRoute = ConfidenceCheckRouteImport.update({
            id: '/confidence-check',path: '/confidence-check',getParentRoute: () => rootRouteImport
          })
const ConfidenceCheckForKidsRoute = ConfidenceCheckForKidsRouteImport.update({
            id: '/confidence-check-for-kids',path: '/confidence-check-for-kids',getParentRoute: () => rootRouteImport
          })
const ContactRoute = ContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => rootRouteImport
          })
const CopyrightPolicyRoute = CopyrightPolicyRouteImport.update({
            id: '/copyright-policy',path: '/copyright-policy',getParentRoute: () => rootRouteImport
          })
const CorrectionsPolicyRoute = CorrectionsPolicyRouteImport.update({
            id: '/corrections-policy',path: '/corrections-policy',getParentRoute: () => rootRouteImport
          })
const EditorialPolicyRoute = EditorialPolicyRouteImport.update({
            id: '/editorial-policy',path: '/editorial-policy',getParentRoute: () => rootRouteImport
          })
const ExpertsRoute = ExpertsRouteImport.update({
            id: '/experts',path: '/experts',getParentRoute: () => rootRouteImport
          })
const FaqRoute = FaqRouteImport.update({
            id: '/faq',path: '/faq',getParentRoute: () => rootRouteImport
          })
const ForParentsRoute = ForParentsRouteImport.update({
            id: '/for-parents',path: '/for-parents',getParentRoute: () => rootRouteImport
          })
const FutureReadinessRoute = FutureReadinessRouteImport.update({
            id: '/future-readiness',path: '/future-readiness',getParentRoute: () => rootRouteImport
          })
const GlossaryRoute = GlossaryRouteImport.update({
            id: '/glossary',path: '/glossary',getParentRoute: () => rootRouteImport
          })
const ImpactRoute = ImpactRouteImport.update({
            id: '/impact',path: '/impact',getParentRoute: () => rootRouteImport
          })
const ImpersonateRoute = ImpersonateRouteImport.update({
            id: '/impersonate',path: '/impersonate',getParentRoute: () => rootRouteImport
          })
const InstallRoute = InstallRouteImport.update({
            id: '/install',path: '/install',getParentRoute: () => rootRouteImport
          })
const LearningJourneysRoute = LearningJourneysRouteImport.update({
            id: '/learning-journeys',path: '/learning-journeys',getParentRoute: () => rootRouteImport
          })
const MembershipCheckoutRoute = MembershipCheckoutRouteImport.update({
            id: '/membership-checkout',path: '/membership-checkout',getParentRoute: () => rootRouteImport
          })
const ParentDashboardRoute = ParentDashboardRouteImport.update({
            id: '/parent-dashboard',path: '/parent-dashboard',getParentRoute: () => rootRouteImport
          })
const PartnerRoute = PartnerRouteImport.update({
            id: '/partner',path: '/partner',getParentRoute: () => rootRouteImport
          })
const PersonalityAssessmentRoute = PersonalityAssessmentRouteImport.update({
            id: '/personality-assessment',path: '/personality-assessment',getParentRoute: () => rootRouteImport
          })
const PressRoute = PressRouteImport.update({
            id: '/press',path: '/press',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const PrivacyPolicyRoute = PrivacyPolicyRouteImport.update({
            id: '/privacy-policy',path: '/privacy-policy',getParentRoute: () => rootRouteImport
          })
const ProfileRoute = ProfileRouteImport.update({
            id: '/profile',path: '/profile',getParentRoute: () => rootRouteImport
          })
const ReferRoute = ReferRouteImport.update({
            id: '/refer',path: '/refer',getParentRoute: () => rootRouteImport
          })
const ReferAndEarnRoute = ReferAndEarnRouteImport.update({
            id: '/refer-and-earn',path: '/refer-and-earn',getParentRoute: () => rootRouteImport
          })
const RefundPolicyRoute = RefundPolicyRouteImport.update({
            id: '/refund-policy',path: '/refund-policy',getParentRoute: () => rootRouteImport
          })
const ResearchMethodologyRoute = ResearchMethodologyRouteImport.update({
            id: '/research-methodology',path: '/research-methodology',getParentRoute: () => rootRouteImport
          })
const ReviewsRoute = ReviewsRouteImport.update({
            id: '/reviews',path: '/reviews',getParentRoute: () => rootRouteImport
          })
const SchoolsRoute = SchoolsRouteImport.update({
            id: '/schools',path: '/schools',getParentRoute: () => rootRouteImport
          })
const ShowcaseRoute = ShowcaseRouteImport.update({
            id: '/showcase',path: '/showcase',getParentRoute: () => rootRouteImport
          })
const TermsRoute = TermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => rootRouteImport
          })
const TermsOfUseRoute = TermsOfUseRouteImport.update({
            id: '/terms-of-use',path: '/terms-of-use',getParentRoute: () => rootRouteImport
          })
const ToolsRoute = ToolsRouteImport.update({
            id: '/tools',path: '/tools',getParentRoute: () => rootRouteImport
          })
const UnsubscribeRoute = UnsubscribeRouteImport.update({
            id: '/unsubscribe',path: '/unsubscribe',getParentRoute: () => rootRouteImport
          })
const WriteToFounderRoute = WriteToFounderRouteImport.update({
            id: '/write-to-founder',path: '/write-to-founder',getParentRoute: () => rootRouteImport
          })
const AdminIndexRoute = AdminIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AdminRouteRoute
          })
const AdminAiVisibilityRoute = AdminAiVisibilityRouteImport.update({
            id: '/ai-visibility',path: '/ai-visibility',getParentRoute: () => AdminRouteRoute
          })
const AdminAssessmentAgeBandsRoute = AdminAssessmentAgeBandsRouteImport.update({
            id: '/assessment-age-bands',path: '/assessment-age-bands',getParentRoute: () => AdminRouteRoute
          })
const AdminAssessmentQuestionsRoute = AdminAssessmentQuestionsRouteImport.update({
            id: '/assessment-questions',path: '/assessment-questions',getParentRoute: () => AdminRouteRoute
          })
const AdminAssessmentSessionsRoute = AdminAssessmentSessionsRouteImport.update({
            id: '/assessment-sessions',path: '/assessment-sessions',getParentRoute: () => AdminRouteRoute
          })
const AdminAssessmentSettingsRoute = AdminAssessmentSettingsRouteImport.update({
            id: '/assessment-settings',path: '/assessment-settings',getParentRoute: () => AdminRouteRoute
          })
const AdminAssessmentTraitsRoute = AdminAssessmentTraitsRouteImport.update({
            id: '/assessment-traits',path: '/assessment-traits',getParentRoute: () => AdminRouteRoute
          })
const AdminBlogAuthorsRoute = AdminBlogAuthorsRouteImport.update({
            id: '/blog-authors',path: '/blog-authors',getParentRoute: () => AdminRouteRoute
          })
const AdminBulkVoiceoverRoute = AdminBulkVoiceoverRouteImport.update({
            id: '/bulk-voiceover',path: '/bulk-voiceover',getParentRoute: () => AdminRouteRoute
          })
const AdminBusinessAnalyticsRoute = AdminBusinessAnalyticsRouteImport.update({
            id: '/business-analytics',path: '/business-analytics',getParentRoute: () => AdminRouteRoute
          })
const AdminCategoriesRoute = AdminCategoriesRouteImport.update({
            id: '/categories',path: '/categories',getParentRoute: () => AdminRouteRoute
          })
const AdminCeoRoute = AdminCeoRouteImport.update({
            id: '/ceo',path: '/ceo',getParentRoute: () => AdminRouteRoute
          })
const AdminCertificatesRoute = AdminCertificatesRouteImport.update({
            id: '/certificates',path: '/certificates',getParentRoute: () => AdminRouteRoute
          })
const AdminCoachChatRoute = AdminCoachChatRouteImport.update({
            id: '/coach-chat',path: '/coach-chat',getParentRoute: () => AdminRouteRoute
          })
const AdminConfidenceCheckRoute = AdminConfidenceCheckRouteImport.update({
            id: '/confidence-check',path: '/confidence-check',getParentRoute: () => AdminRouteRoute
          })
const AdminContentCheckerRoute = AdminContentCheckerRouteImport.update({
            id: '/content-checker',path: '/content-checker',getParentRoute: () => AdminRouteRoute
          })
const AdminCourseBackgroundsRoute = AdminCourseBackgroundsRouteImport.update({
            id: '/course-backgrounds',path: '/course-backgrounds',getParentRoute: () => AdminRouteRoute
          })
const AdminCourseGeneratorRoute = AdminCourseGeneratorRouteImport.update({
            id: '/course-generator',path: '/course-generator',getParentRoute: () => AdminRouteRoute
          })
const AdminCspReportsRoute = AdminCspReportsRouteImport.update({
            id: '/csp-reports',path: '/csp-reports',getParentRoute: () => AdminRouteRoute
          })
const AdminDataAnalyticsRoute = AdminDataAnalyticsRouteImport.update({
            id: '/data-analytics',path: '/data-analytics',getParentRoute: () => AdminRouteRoute
          })
const AdminDialogueCharactersRoute = AdminDialogueCharactersRouteImport.update({
            id: '/dialogue-characters',path: '/dialogue-characters',getParentRoute: () => AdminRouteRoute
          })
const AdminEdgeCacheRoute = AdminEdgeCacheRouteImport.update({
            id: '/edge-cache',path: '/edge-cache',getParentRoute: () => AdminRouteRoute
          })
const AdminElevenlabsKeysRoute = AdminElevenlabsKeysRouteImport.update({
            id: '/elevenlabs-keys',path: '/elevenlabs-keys',getParentRoute: () => AdminRouteRoute
          })
const AdminErrorTrackingRoute = AdminErrorTrackingRouteImport.update({
            id: '/error-tracking',path: '/error-tracking',getParentRoute: () => AdminRouteRoute
          })
const AdminFounderMessagesRoute = AdminFounderMessagesRouteImport.update({
            id: '/founder-messages',path: '/founder-messages',getParentRoute: () => AdminRouteRoute
          })
const AdminFutureReadinessRoute = AdminFutureReadinessRouteImport.update({
            id: '/future-readiness',path: '/future-readiness',getParentRoute: () => AdminRouteRoute
          })
const AdminInfluencersRoute = AdminInfluencersRouteImport.update({
            id: '/influencers',path: '/influencers',getParentRoute: () => AdminRouteRoute
          })
const AdminLandingPagesRoute = AdminLandingPagesRouteImport.update({
            id: '/landing-pages',path: '/landing-pages',getParentRoute: () => AdminRouteRoute
          })
const AdminLanguagesRoute = AdminLanguagesRouteImport.update({
            id: '/languages',path: '/languages',getParentRoute: () => AdminRouteRoute
          })
const AdminLearningJourneysRoute = AdminLearningJourneysRouteImport.update({
            id: '/learning-journeys',path: '/learning-journeys',getParentRoute: () => AdminRouteRoute
          })
const AdminLogoRoute = AdminLogoRouteImport.update({
            id: '/logo',path: '/logo',getParentRoute: () => AdminRouteRoute
          })
const AdminMediaLibraryRoute = AdminMediaLibraryRouteImport.update({
            id: '/media-library',path: '/media-library',getParentRoute: () => AdminRouteRoute
          })
const AdminMetaEventsRoute = AdminMetaEventsRouteImport.update({
            id: '/meta-events',path: '/meta-events',getParentRoute: () => AdminRouteRoute
          })
const AdminMetaPlanEventsRoute = AdminMetaPlanEventsRouteImport.update({
            id: '/meta-plan-events',path: '/meta-plan-events',getParentRoute: () => AdminRouteRoute
          })
const AdminMonitoringRoute = AdminMonitoringRouteImport.update({
            id: '/monitoring',path: '/monitoring',getParentRoute: () => AdminRouteRoute
          })
const AdminOtpAttemptsRoute = AdminOtpAttemptsRouteImport.update({
            id: '/otp-attempts',path: '/otp-attempts',getParentRoute: () => AdminRouteRoute
          })
const AdminParentJourneyRoute = AdminParentJourneyRouteImport.update({
            id: '/parent-journey',path: '/parent-journey',getParentRoute: () => AdminRouteRoute
          })
const AdminPaymentHealthRoute = AdminPaymentHealthRouteImport.update({
            id: '/payment-health',path: '/payment-health',getParentRoute: () => AdminRouteRoute
          })
const AdminPaymentReconciliationRoute = AdminPaymentReconciliationRouteImport.update({
            id: '/payment-reconciliation',path: '/payment-reconciliation',getParentRoute: () => AdminRouteRoute
          })
const AdminPricingAuditRoute = AdminPricingAuditRouteImport.update({
            id: '/pricing-audit',path: '/pricing-audit',getParentRoute: () => AdminRouteRoute
          })
const AdminPromoCodesRoute = AdminPromoCodesRouteImport.update({
            id: '/promo-codes',path: '/promo-codes',getParentRoute: () => AdminRouteRoute
          })
const AdminPublishCheckRoute = AdminPublishCheckRouteImport.update({
            id: '/publish-check',path: '/publish-check',getParentRoute: () => AdminRouteRoute
          })
const AdminReceiptsRoute = AdminReceiptsRouteImport.update({
            id: '/receipts',path: '/receipts',getParentRoute: () => AdminRouteRoute
          })
const AdminReferralsRoute = AdminReferralsRouteImport.update({
            id: '/referrals',path: '/referrals',getParentRoute: () => AdminRouteRoute
          })
const AdminRegionalPricingRoute = AdminRegionalPricingRouteImport.update({
            id: '/regional-pricing',path: '/regional-pricing',getParentRoute: () => AdminRouteRoute
          })
const AdminSeoRoute = AdminSeoRouteImport.update({
            id: '/seo',path: '/seo',getParentRoute: () => AdminRouteRoute
          })
const AdminSubscriptionsRoute = AdminSubscriptionsRouteImport.update({
            id: '/subscriptions',path: '/subscriptions',getParentRoute: () => AdminRouteRoute
          })
const AdminTestimonialsRoute = AdminTestimonialsRouteImport.update({
            id: '/testimonials',path: '/testimonials',getParentRoute: () => AdminRouteRoute
          })
const AdminTrashRoute = AdminTrashRouteImport.update({
            id: '/trash',path: '/trash',getParentRoute: () => AdminRouteRoute
          })
const AdminUserAnalyticsRoute = AdminUserAnalyticsRouteImport.update({
            id: '/user-analytics',path: '/user-analytics',getParentRoute: () => AdminRouteRoute
          })
const AdminUserReportsRoute = AdminUserReportsRouteImport.update({
            id: '/user-reports',path: '/user-reports',getParentRoute: () => AdminRouteRoute
          })
const AdminUsersRoute = AdminUsersRouteImport.update({
            id: '/users',path: '/users',getParentRoute: () => AdminRouteRoute
          })
const AdminUtmBuilderRoute = AdminUtmBuilderRouteImport.update({
            id: '/utm-builder',path: '/utm-builder',getParentRoute: () => AdminRouteRoute
          })
const AdminUtmFunnelRoute = AdminUtmFunnelRouteImport.update({
            id: '/utm-funnel',path: '/utm-funnel',getParentRoute: () => AdminRouteRoute
          })
const AdminVisitorQueriesRoute = AdminVisitorQueriesRouteImport.update({
            id: '/visitor-queries',path: '/visitor-queries',getParentRoute: () => AdminRouteRoute
          })
const AdminVoiceoverQueueRoute = AdminVoiceoverQueueRouteImport.update({
            id: '/voiceover-queue',path: '/voiceover-queue',getParentRoute: () => AdminRouteRoute
          })
const AdminWebhookEventsRoute = AdminWebhookEventsRouteImport.update({
            id: '/webhook-events',path: '/webhook-events',getParentRoute: () => AdminRouteRoute
          })
const AssessmentIndexRoute = AssessmentIndexRouteImport.update({
            id: '/assessment/',path: '/assessment/',getParentRoute: () => rootRouteImport
          })
const AssessmentSampleReportRoute = AssessmentSampleReportRouteImport.update({
            id: '/assessment/sample-report',path: '/assessment/sample-report',getParentRoute: () => rootRouteImport
          })
const AssessmentStartRoute = AssessmentStartRouteImport.update({
            id: '/assessment/start',path: '/assessment/start',getParentRoute: () => rootRouteImport
          })
const AssessmentsIndexRoute = AssessmentsIndexRouteImport.update({
            id: '/assessments/',path: '/assessments/',getParentRoute: () => rootRouteImport
          })
const AssessmentsSlugRoute = AssessmentsSlugRouteImport.update({
            id: '/assessments/$slug',path: '/assessments/$slug',getParentRoute: () => rootRouteImport
          })
const AuthIndexRoute = AuthIndexRouteImport.update({
            id: '/auth/',path: '/auth/',getParentRoute: () => rootRouteImport
          })
const AuthCallbackRoute = AuthCallbackRouteImport.update({
            id: '/auth/callback',path: '/auth/callback',getParentRoute: () => rootRouteImport
          })
const AuthDebugRoute = AuthDebugRouteImport.update({
            id: '/auth/debug',path: '/auth/debug',getParentRoute: () => rootRouteImport
          })
const BlogIndexRoute = BlogIndexRouteImport.update({
            id: '/blog/',path: '/blog/',getParentRoute: () => rootRouteImport
          })
const BlogSlugRoute = BlogSlugRouteImport.update({
            id: '/blog/$slug',path: '/blog/$slug',getParentRoute: () => rootRouteImport
          })
const BlogAuthorsRoute = BlogAuthorsRouteImport.update({
            id: '/blog/authors',path: '/blog/authors',getParentRoute: () => rootRouteImport
          })
const CaseStudiesIndexRoute = CaseStudiesIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => CaseStudiesRoute
          })
const CaseStudiesSlugRoute = CaseStudiesSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => CaseStudiesRoute
          })
const CharactersIndexRoute = CharactersIndexRouteImport.update({
            id: '/characters/',path: '/characters/',getParentRoute: () => rootRouteImport
          })
const CharactersNameRoute = CharactersNameRouteImport.update({
            id: '/characters/$name',path: '/characters/$name',getParentRoute: () => rootRouteImport
          })
const CourseTrialIndexRoute = CourseTrialIndexRouteImport.update({
            id: '/course-trial/',path: '/course-trial/',getParentRoute: () => rootRouteImport
          })
const CourseTrialCourseIdRoute = CourseTrialCourseIdRouteImport.update({
            id: '/course-trial/$courseId',path: '/course-trial/$courseId',getParentRoute: () => rootRouteImport
          })
const CourseCourseIdRoute = CourseCourseIdRouteImport.update({
            id: '/course/$courseId',path: '/course/$courseId',getParentRoute: () => rootRouteImport
          })
const CoursesIndexRoute = CoursesIndexRouteImport.update({
            id: '/courses/',path: '/courses/',getParentRoute: () => rootRouteImport
          })
const CoursesSlugRoute = CoursesSlugRouteImport.update({
            id: '/courses/$slug',path: '/courses/$slug',getParentRoute: () => rootRouteImport
          })
const LearnIndexRoute = LearnIndexRouteImport.update({
            id: '/learn/',path: '/learn/',getParentRoute: () => rootRouteImport
          })
const LearnSlugRoute = LearnSlugRouteImport.update({
            id: '/learn/$slug',path: '/learn/$slug',getParentRoute: () => rootRouteImport
          })
const LpSlugRoute = LpSlugRouteImport.update({
            id: '/lp/$slug',path: '/lp/$slug',getParentRoute: () => rootRouteImport
          })
const MeetIndexRoute = MeetIndexRouteImport.update({
            id: '/meet/',path: '/meet/',getParentRoute: () => rootRouteImport
          })
const MeetNameRoute = MeetNameRouteImport.update({
            id: '/meet/$name',path: '/meet/$name',getParentRoute: () => rootRouteImport
          })
const ParentPinResetRoute = ParentPinResetRouteImport.update({
            id: '/parent/pin-reset',path: '/parent/pin-reset',getParentRoute: () => rootRouteImport
          })
const PartnersApplyRoute = PartnersApplyRouteImport.update({
            id: '/partners/apply',path: '/partners/apply',getParentRoute: () => rootRouteImport
          })
const RSlugRoute = RSlugRouteImport.update({
            id: '/r/$slug',path: '/r/$slug',getParentRoute: () => rootRouteImport
          })
const ResearchIndexRoute = ResearchIndexRouteImport.update({
            id: '/research/',path: '/research/',getParentRoute: () => rootRouteImport
          })
const ResearchSlugRoute = ResearchSlugRouteImport.update({
            id: '/research/$slug',path: '/research/$slug',getParentRoute: () => rootRouteImport
          })
const SubscriptionIndexRoute = SubscriptionIndexRouteImport.update({
            id: '/subscription/',path: '/subscription/',getParentRoute: () => rootRouteImport
          })
const SubscriptionSuccessAnnualRoute = SubscriptionSuccessAnnualRouteImport.update({
            id: '/subscription/success-annual',path: '/subscription/success-annual',getParentRoute: () => rootRouteImport
          })
const SubscriptionSuccessAssessmentRoute = SubscriptionSuccessAssessmentRouteImport.update({
            id: '/subscription/success-assessment',path: '/subscription/success-assessment',getParentRoute: () => rootRouteImport
          })
const SubscriptionSuccessPassRoute = SubscriptionSuccessPassRouteImport.update({
            id: '/subscription/success-pass',path: '/subscription/success-pass',getParentRoute: () => rootRouteImport
          })
const SubscriptionSuccessQuarterlyRoute = SubscriptionSuccessQuarterlyRouteImport.update({
            id: '/subscription/success-quarterly',path: '/subscription/success-quarterly',getParentRoute: () => rootRouteImport
          })
const SubscriptionSuccessReportRoute = SubscriptionSuccessReportRouteImport.update({
            id: '/subscription/success-report',path: '/subscription/success-report',getParentRoute: () => rootRouteImport
          })
const SubscriptionSuccessTrialRoute = SubscriptionSuccessTrialRouteImport.update({
            id: '/subscription/success-trial',path: '/subscription/success-trial',getParentRoute: () => rootRouteImport
          })
const ToolsIndexRoute = ToolsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => ToolsRoute
          })
const ToolsSlugRoute = ToolsSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => ToolsRoute
          })
const TopicsIndexRoute = TopicsIndexRouteImport.update({
            id: '/topics/',path: '/topics/',getParentRoute: () => rootRouteImport
          })
const TopicsSlugRoute = TopicsSlugRouteImport.update({
            id: '/topics/$slug',path: '/topics/$slug',getParentRoute: () => rootRouteImport
          })
const VsSlugRoute = VsSlugRouteImport.update({
            id: '/vs/$slug',path: '/vs/$slug',getParentRoute: () => rootRouteImport
          })
const DotlovableOauthConsentRoute = DotlovableOauthConsentRouteImport.update({
            id: '/.lovable/oauth/consent',path: '/.lovable/oauth/consent',getParentRoute: () => rootRouteImport
          })
const AdminCoursesIndexRoute = AdminCoursesIndexRouteImport.update({
            id: '/courses/',path: '/courses/',getParentRoute: () => AdminRouteRoute
          })
const AdminParentAssessmentsIndexRoute = AdminParentAssessmentsIndexRouteImport.update({
            id: '/parent-assessments/',path: '/parent-assessments/',getParentRoute: () => AdminRouteRoute
          })
const AdminParentAssessmentsSlugRoute = AdminParentAssessmentsSlugRouteImport.update({
            id: '/parent-assessments/$slug',path: '/parent-assessments/$slug',getParentRoute: () => AdminRouteRoute
          })
const AssessmentChildSessionIdRoute = AssessmentChildSessionIdRouteImport.update({
            id: '/assessment/child/$sessionId',path: '/assessment/child/$sessionId',getParentRoute: () => rootRouteImport
          })
const AssessmentParentSessionIdRoute = AssessmentParentSessionIdRouteImport.update({
            id: '/assessment/parent/$sessionId',path: '/assessment/parent/$sessionId',getParentRoute: () => rootRouteImport
          })
const AssessmentReportSessionIdRoute = AssessmentReportSessionIdRouteImport.update({
            id: '/assessment/report/$sessionId',path: '/assessment/report/$sessionId',getParentRoute: () => rootRouteImport
          })
const GoCodeIndexRoute = GoCodeIndexRouteImport.update({
            id: '/go/$code/',path: '/go/$code/',getParentRoute: () => rootRouteImport
          })
const GoCodeCampaignSlugRoute = GoCodeCampaignSlugRouteImport.update({
            id: '/go/$code/$campaignSlug',path: '/go/$code/$campaignSlug',getParentRoute: () => rootRouteImport
          })
const SubscriptionSuccessIndexRoute = SubscriptionSuccessIndexRouteImport.update({
            id: '/subscription/success/',path: '/subscription/success/',getParentRoute: () => rootRouteImport
          })
const SubscriptionSuccessPlanKindRoute = SubscriptionSuccessPlanKindRouteImport.update({
            id: '/subscription/success/$planKind',path: '/subscription/success/$planKind',getParentRoute: () => rootRouteImport
          })
const AdminCoursesCourseIdIndexRoute = AdminCoursesCourseIdIndexRouteImport.update({
            id: '/courses/$courseId/',path: '/courses/$courseId/',getParentRoute: () => AdminRouteRoute
          })
const AdminCoursesCourseIdReviewRoute = AdminCoursesCourseIdReviewRouteImport.update({
            id: '/courses/$courseId/review',path: '/courses/$courseId/review',getParentRoute: () => AdminRouteRoute
          })
const AdminCoursesCourseIdTestRoute = AdminCoursesCourseIdTestRouteImport.update({
            id: '/courses/$courseId/test',path: '/courses/$courseId/test',getParentRoute: () => AdminRouteRoute
          })
const AdminCoursesCourseIdVersionsRoute = AdminCoursesCourseIdVersionsRouteImport.update({
            id: '/courses/$courseId/versions',path: '/courses/$courseId/versions',getParentRoute: () => AdminRouteRoute
          })





const AdminRouteRouteChildren = {
  AdminAiVisibilityRoute: AdminAiVisibilityRoute,AdminAssessmentAgeBandsRoute: AdminAssessmentAgeBandsRoute,AdminAssessmentQuestionsRoute: AdminAssessmentQuestionsRoute,AdminAssessmentSessionsRoute: AdminAssessmentSessionsRoute,AdminAssessmentSettingsRoute: AdminAssessmentSettingsRoute,AdminAssessmentTraitsRoute: AdminAssessmentTraitsRoute,AdminBlogAuthorsRoute: AdminBlogAuthorsRoute,AdminBulkVoiceoverRoute: AdminBulkVoiceoverRoute,AdminBusinessAnalyticsRoute: AdminBusinessAnalyticsRoute,AdminCategoriesRoute: AdminCategoriesRoute,AdminCeoRoute: AdminCeoRoute,AdminCertificatesRoute: AdminCertificatesRoute,AdminCoachChatRoute: AdminCoachChatRoute,AdminConfidenceCheckRoute: AdminConfidenceCheckRoute,AdminContentCheckerRoute: AdminContentCheckerRoute,AdminCourseBackgroundsRoute: AdminCourseBackgroundsRoute,AdminCourseGeneratorRoute: AdminCourseGeneratorRoute,AdminCspReportsRoute: AdminCspReportsRoute,AdminDataAnalyticsRoute: AdminDataAnalyticsRoute,AdminDialogueCharactersRoute: AdminDialogueCharactersRoute,AdminEdgeCacheRoute: AdminEdgeCacheRoute,AdminElevenlabsKeysRoute: AdminElevenlabsKeysRoute,AdminErrorTrackingRoute: AdminErrorTrackingRoute,AdminFounderMessagesRoute: AdminFounderMessagesRoute,AdminFutureReadinessRoute: AdminFutureReadinessRoute,AdminInfluencersRoute: AdminInfluencersRoute,AdminLandingPagesRoute: AdminLandingPagesRoute,AdminLanguagesRoute: AdminLanguagesRoute,AdminLearningJourneysRoute: AdminLearningJourneysRoute,AdminLogoRoute: AdminLogoRoute,AdminMediaLibraryRoute: AdminMediaLibraryRoute,AdminMetaEventsRoute: AdminMetaEventsRoute,AdminMetaPlanEventsRoute: AdminMetaPlanEventsRoute,AdminMonitoringRoute: AdminMonitoringRoute,AdminOtpAttemptsRoute: AdminOtpAttemptsRoute,AdminParentJourneyRoute: AdminParentJourneyRoute,AdminPaymentHealthRoute: AdminPaymentHealthRoute,AdminPaymentReconciliationRoute: AdminPaymentReconciliationRoute,AdminPricingAuditRoute: AdminPricingAuditRoute,AdminPromoCodesRoute: AdminPromoCodesRoute,AdminPublishCheckRoute: AdminPublishCheckRoute,AdminReceiptsRoute: AdminReceiptsRoute,AdminReferralsRoute: AdminReferralsRoute,AdminRegionalPricingRoute: AdminRegionalPricingRoute,AdminSeoRoute: AdminSeoRoute,AdminSubscriptionsRoute: AdminSubscriptionsRoute,AdminTestimonialsRoute: AdminTestimonialsRoute,AdminTrashRoute: AdminTrashRoute,AdminUserAnalyticsRoute: AdminUserAnalyticsRoute,AdminUserReportsRoute: AdminUserReportsRoute,AdminUsersRoute: AdminUsersRoute,AdminUtmBuilderRoute: AdminUtmBuilderRoute,AdminUtmFunnelRoute: AdminUtmFunnelRoute,AdminVisitorQueriesRoute: AdminVisitorQueriesRoute,AdminVoiceoverQueueRoute: AdminVoiceoverQueueRoute,AdminWebhookEventsRoute: AdminWebhookEventsRoute,AdminIndexRoute: AdminIndexRoute,AdminParentAssessmentsSlugRoute: AdminParentAssessmentsSlugRoute,AdminCoursesIndexRoute: AdminCoursesIndexRoute,AdminParentAssessmentsIndexRoute: AdminParentAssessmentsIndexRoute,AdminCoursesCourseIdReviewRoute: AdminCoursesCourseIdReviewRoute,AdminCoursesCourseIdTestRoute: AdminCoursesCourseIdTestRoute,AdminCoursesCourseIdVersionsRoute: AdminCoursesCourseIdVersionsRoute,AdminCoursesCourseIdIndexRoute: AdminCoursesCourseIdIndexRoute
}

const AdminRouteRouteWithChildren = AdminRouteRoute._addFileChildren(AdminRouteRouteChildren)




const CaseStudiesRouteChildren = {
  CaseStudiesSlugRoute: CaseStudiesSlugRoute,CaseStudiesIndexRoute: CaseStudiesIndexRoute
}

const CaseStudiesRouteWithChildren = CaseStudiesRoute._addFileChildren(CaseStudiesRouteChildren)




const ToolsRouteChildren = {
  ToolsSlugRoute: ToolsSlugRoute,ToolsIndexRoute: ToolsIndexRoute
}

const ToolsRouteWithChildren = ToolsRoute._addFileChildren(ToolsRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AdminRouteRoute: AdminRouteRouteWithChildren,AboutRoute: AboutRoute,CaseStudiesRoute: CaseStudiesRouteWithChildren,CoachRoute: CoachRoute,ConfidenceRoute: ConfidenceRoute,ConfidenceCheckRoute: ConfidenceCheckRoute,ConfidenceCheckForKidsRoute: ConfidenceCheckForKidsRoute,ContactRoute: ContactRoute,CopyrightPolicyRoute: CopyrightPolicyRoute,CorrectionsPolicyRoute: CorrectionsPolicyRoute,EditorialPolicyRoute: EditorialPolicyRoute,ExpertsRoute: ExpertsRoute,FaqRoute: FaqRoute,ForParentsRoute: ForParentsRoute,FutureReadinessRoute: FutureReadinessRoute,GlossaryRoute: GlossaryRoute,ImpactRoute: ImpactRoute,ImpersonateRoute: ImpersonateRoute,InstallRoute: InstallRoute,LearningJourneysRoute: LearningJourneysRoute,MembershipCheckoutRoute: MembershipCheckoutRoute,ParentDashboardRoute: ParentDashboardRoute,PartnerRoute: PartnerRoute,PersonalityAssessmentRoute: PersonalityAssessmentRoute,PressRoute: PressRoute,PrivacyRoute: PrivacyRoute,PrivacyPolicyRoute: PrivacyPolicyRoute,ProfileRoute: ProfileRoute,ReferRoute: ReferRoute,ReferAndEarnRoute: ReferAndEarnRoute,RefundPolicyRoute: RefundPolicyRoute,ResearchMethodologyRoute: ResearchMethodologyRoute,ReviewsRoute: ReviewsRoute,SchoolsRoute: SchoolsRoute,ShowcaseRoute: ShowcaseRoute,TermsRoute: TermsRoute,TermsOfUseRoute: TermsOfUseRoute,ToolsRoute: ToolsRouteWithChildren,UnsubscribeRoute: UnsubscribeRoute,WriteToFounderRoute: WriteToFounderRoute,AssessmentSampleReportRoute: AssessmentSampleReportRoute,AssessmentStartRoute: AssessmentStartRoute,AssessmentsSlugRoute: AssessmentsSlugRoute,AuthCallbackRoute: AuthCallbackRoute,AuthDebugRoute: AuthDebugRoute,BlogSlugRoute: BlogSlugRoute,BlogAuthorsRoute: BlogAuthorsRoute,CharactersNameRoute: CharactersNameRoute,CourseTrialCourseIdRoute: CourseTrialCourseIdRoute,CourseCourseIdRoute: CourseCourseIdRoute,CoursesSlugRoute: CoursesSlugRoute,LearnSlugRoute: LearnSlugRoute,LpSlugRoute: LpSlugRoute,MeetNameRoute: MeetNameRoute,ParentPinResetRoute: ParentPinResetRoute,PartnersApplyRoute: PartnersApplyRoute,RSlugRoute: RSlugRoute,ResearchSlugRoute: ResearchSlugRoute,SubscriptionSuccessAnnualRoute: SubscriptionSuccessAnnualRoute,SubscriptionSuccessAssessmentRoute: SubscriptionSuccessAssessmentRoute,SubscriptionSuccessPassRoute: SubscriptionSuccessPassRoute,SubscriptionSuccessQuarterlyRoute: SubscriptionSuccessQuarterlyRoute,SubscriptionSuccessReportRoute: SubscriptionSuccessReportRoute,SubscriptionSuccessTrialRoute: SubscriptionSuccessTrialRoute,TopicsSlugRoute: TopicsSlugRoute,VsSlugRoute: VsSlugRoute,AssessmentIndexRoute: AssessmentIndexRoute,AssessmentsIndexRoute: AssessmentsIndexRoute,AuthIndexRoute: AuthIndexRoute,BlogIndexRoute: BlogIndexRoute,CharactersIndexRoute: CharactersIndexRoute,CourseTrialIndexRoute: CourseTrialIndexRoute,CoursesIndexRoute: CoursesIndexRoute,LearnIndexRoute: LearnIndexRoute,MeetIndexRoute: MeetIndexRoute,ResearchIndexRoute: ResearchIndexRoute,SubscriptionIndexRoute: SubscriptionIndexRoute,TopicsIndexRoute: TopicsIndexRoute,DotlovableOauthConsentRoute: DotlovableOauthConsentRoute,AssessmentChildSessionIdRoute: AssessmentChildSessionIdRoute,AssessmentParentSessionIdRoute: AssessmentParentSessionIdRoute,AssessmentReportSessionIdRoute: AssessmentReportSessionIdRoute,GoCodeCampaignSlugRoute: GoCodeCampaignSlugRoute,SubscriptionSuccessPlanKindRoute: SubscriptionSuccessPlanKindRoute,GoCodeIndexRoute: GoCodeIndexRoute,SubscriptionSuccessIndexRoute: SubscriptionSuccessIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)